var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Anahtar kelime "),_c('b',[_vm._v("Slug")]),_vm._v(" değerinde bulunmalı.")])])}]

export { render, staticRenderFns }